<mat-card class="menupannel">
    <div class="resUser">
      <button mat-flat-button (click)="showMyDrive()">
        Main Workspace <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
    <!-- <div class="d">
      <button mat-flat-button (click)="showDocDetail()">
        <mat-icon>keyboard_arrow_left</mat-icon> Details
      </button>
    </div> -->
  </mat-card>
  
  
  <div class="taskcontainer">
  
      <!-- My Drive -->
      <mat-card class="myDrive" [ngClass]="{'open': showmyDrive }">
  
        <div class="createdfolder">
          <div class="drive mainLink">
            <div class="mWorkspace">
              <h2>My Drive</h2>
              <button mat-icon-button color="primary" >
                <mat-icon>create_new_folder</mat-icon>
              </button>
            </div>
            <div class="folderName" >
              <div class="nm">
                <mat-icon class="type" >folder</mat-icon> All Task  
                 <div class="taskstatus">
                  102/125   
                </div> 
              </div>
              <div class="opt">
                <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>more_vertical</mat-icon></button>
              </div>
            </div>
            <div class="folderName" >
              <div class="nm">
                <mat-icon class="type" >folder</mat-icon> Heart Surgery
                <div class="taskstatus">
                  2/5   
                </div> 
              </div>
              <div class="opt">
                <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>more_vertical</mat-icon></button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item><mat-icon>edit</mat-icon> Rename folder</button>              
                  <button mat-menu-item><mat-icon>library_add</mat-icon> Add Template</button>
                  <button mat-menu-item><mat-icon>save</mat-icon> Save as Template</button>
                  <button mat-menu-item> <mat-icon>delete</mat-icon> Remove Folder</button>
                </mat-menu>
              </div>
            </div>
            <div class="folderName" >
              <div class="nm">
                <mat-icon class="type" >folder</mat-icon> Registration 
                <!-- <div class="taskstatus">
                  <mat-icon class="complete"  matBadge="2" matBadgeColor="basic">check_circle</mat-icon>
                  <mat-icon class="working" matBadge="3" matBadgeColor="basic">check_circle</mat-icon>   
                </div>  -->
                <div class="taskstatus">
                  5/10   
                </div>
              </div>
              <div class="opt">
                <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>more_vertical</mat-icon></button>
              </div>
            </div>
            <div class="folderName active" >
              <div class="nm">
                <mat-icon class="type" >folder_shared</mat-icon> Discharge 
                <!-- <div class="taskstatus">
                  <mat-icon class="complete"  matBadge="2" matBadgeColor="basic">check_circle</mat-icon>
                  <mat-icon class="working" matBadge="3" matBadgeColor="basic">check_circle</mat-icon>   
                </div>  -->
                <div class="taskstatus">
                  1/3   
                </div>
              </div>
              <div class="opt">
                <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>more_vertical</mat-icon></button>
              </div>
            </div>
           </div>
        </div> 
       
      </mat-card>
      <div class="myDriveOverlay" (click)="showMyDrive()" [ngClass]="{'open': showmyDrive }"></div>
      <!-- My Drive -->
  
  
  <div class="right">
    <mat-card class="filter">
  
      <div class="pageHeading" >
        <!-- <button mat-button [matMenuTriggerFor]="taskview">
          <mat-icon>table_view</mat-icon> Table
          
          <mat-icon>keyboard_arrow_down</mat-icon></button>
        <mat-menu #taskview="matMenu">
          <button mat-menu-item><mat-icon>insert_invitation</mat-icon>Calender</button>
          <button mat-menu-item><mat-icon>clear_all</mat-icon> Gantt</button>
        </mat-menu> -->
        <span [routerLink]="'/task'"  ><mat-icon>table_view</mat-icon> Table</span>
        <span class="active" [routerLink]="'/task/gantt'"    ><mat-icon>clear_all</mat-icon> Gantt</span>
      </div>  
  
      <div class="search">
        <div class="sort">
  
          <mat-form-field appearance="">
            <mat-label>Sort By</mat-label>
            <mat-select>
              <mat-option value="All">All</mat-option>
              <mat-option value="Starred">Starred</mat-option>
              <mat-option value="Priority">Priority</mat-option>
              <mat-option value="Scheduled">Scheduled</mat-option>
              <mat-option value="Today">Today</mat-option>
              <mat-option value="Done">Done</mat-option>
              <mat-option value="Deleted">Deleted</mat-option>
            </mat-select>
          </mat-form-field>
    
        </div>
        <mat-form-field appearance="">
          <mat-label>Search task</mat-label>
          <input matInput type="text" >
          <button mat-button  matSuffix mat-icon-button >
            <mat-icon>close</mat-icon>
          </button>
          
        </mat-form-field>
  
        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Customize Coloumn">
          <mat-icon>view_column</mat-icon>
        </button>
        <button mat-icon-button matTooltipClass="tooltip" matTooltip="Filters">
          <mat-icon>filter_list</mat-icon>
        </button>
        <!-- <button mat-flat-button color="primary" class="addnew" (click)="createNewTask(true)" >  Add Task </button> -->
      </div>
  
    </mat-card>
    <!-- Filter -->
  
  
    <mat-card class="allTaskHolder">
  
        <ng-gantt [options]="editorOptions" [data]="data"></ng-gantt>

   
    </mat-card>
  
  
  </div>
  </div>
  


  